// extracted by mini-css-extract-plugin
export var heroImage = "_ef-1";
export var modal = "_ef-0";